export default async function (item: any) {
  const json: IData = await item.json()

  if ('error' in json) {
    throw new Error(json.messages[0])
  }

  return json
}

export type TListing = {
  bathrooms: number
  bedbooking_id_room: number
  bedrooms: number
  beds: number
  currency: string
  id: number
  name: string
  price: number
}

export interface IData {
  error?: string
  messages?: string[]
  items: TListing[]
}
